import Vue from 'vue'
import VueRouter from 'vue-router'
import physical from '../../components/physical/physical'
import physicalOrg from '../../components/physical/physical_org'
import physicalOrgDet from '../../components/physical/physical_org_det'
import physicalOrgRep from '../../components/physical/physical_report.vue'
import physicalOrgRepSd from '../../components/physical/physical_reportSd.vue'
import teacherPhy from '../../components/physical/teacherPhy'
import teacherAdd from '../../components/physical/teacherPhyAdd'
import teacherEdit from '../../components/physical/teacherPhyEdit'
import teacherDet from '../../components/physical/teacherPhyDet'
import phyImport from '../../components/physical/import'
import childPhy from '../../components/physical/childPhy'
import childPhyDetail from '../../components/physical/childPhyDetail'
import childPhyPrint from '../../components/physical/childPhyPrint'
import childPhyPrintSd from '../../components/physical/childPhyPrintSd'
import childPhyPrintBatch from '../../components/physical/childPhyPrintBatch'
import childPhyPrintSdBatch from '../../components/physical/childPhyPrintSdBatch'
import childPhyImport from '../../components/physical/childPhyImport'
import childPhyAdd from '../../components/physical/childPhyAdd'
import childPhyEdit from '../../components/physical/childPhyEdit'
import issued from '../../components/physical/issued'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: physical
  },
  {
    path: '/physical',
    component: physical,
    children: [

    ]
  },
  {
    path: '/teacherPhy',
    component: teacherPhy,
    children: [
      {
        path: 'add',
        component: teacherAdd
      },
      {
        path: 'edit/:id',
        component: teacherEdit
      },
      {
        path: 'detail/:id',
        component: teacherDet
      },
      {
        path: 'import',
        component: phyImport
      }
    ]
  },
  {
    path: '/physical_org',
    component: physicalOrg,
    children: [
      {
        path: 'detail/',
        component: physicalOrgDet,
        children: [
          {
            path: 'dReports',
            component: physicalOrgRep
          },
          {
            path: 'dReportsSd',
            component: physicalOrgRepSd
          }
        ]
      },
      {
        path: 'reports/:id',
        component: physicalOrgRep
      },
      {
        path: 'reportsSd/:id',
        component: physicalOrgRepSd
      }
    ]
  },
  {
    path: '/childPhy',
    component: childPhy,
    children: [
      {
        path: 'edit/:id',
        component: childPhyEdit
      },
      {
        path: 'issued',
        component: issued
      },
      {
        path: 'add',
        component: childPhyAdd
      },
      {
        path: 'detail/',
        component: childPhyDetail,
        children: [
          {
            path: 'print/',
            component: childPhyPrint
          },
          {
            path: 'printSd/',
            component: childPhyPrintSd
          },
        ]
      },
      {
        path: 'print/',
        component: childPhyPrint
      },
      {
        path: 'printSd/',
        component: childPhyPrintSd
      },
      {
        path: 'printBatch/',
        component: childPhyPrintBatch
      },
      {
        path: 'printSdBatch/',
        component: childPhyPrintSdBatch
      },
      {
        path: 'import',
        component: childPhyImport
      }
    ]
  }
]

// 3. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
export default new VueRouter({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/physical/physical.js